import { CHANGE_AWB_NUMBER } from '../actions/actionTypes';

interface AwbSelect {
  selectedAwbCode: string;
  selectedAwbNumber: string;
  changed: boolean;
};

const initState: AwbSelect = {
  selectedAwbCode: '',
  selectedAwbNumber: '',
  changed: false
};

export const selectAwbReducer = (state: AwbSelect = initState, action: any) => {

  switch (action.type) {

    case CHANGE_AWB_NUMBER:
      return {
        ...state,
        selectedAwbCode: action.data.awbCode,
        selectedAwbNumber: action.data.awbNumber,
        changed: action.data.changed
      };

    default: return state;
  }
};